import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { EComponentsMode } from './typings';

@Injectable({
    providedIn: 'root'
})
export class SettingsPanelService {
    isInverseHeader = new ReplaySubject<boolean>();
    isInverseMenu = new ReplaySubject<boolean>();

    constructor() { }

    toggleHeaderMode(mode: EComponentsMode | string): void {
        this.isInverseHeader.next(mode === EComponentsMode.light);
    }

    toggleMenuMode(mode: EComponentsMode | string): void {
        this.isInverseMenu.next(mode === EComponentsMode.dark);
    }

    public setItemToStorage(key: string, value: string) {
        localStorage.setItem(key, value);
    }

    public getItemToStorage(key: string) {
        return localStorage.getItem(key)
    }
}
